import { useCallback, useEffect } from 'react';
import { Tracking, PageTrackingInfo, ClickTrackingInfo } from 'api';

export const usePageTracking = (infoResolver: () => PageTrackingInfo): void => {
  useEffect(() => {
    Tracking.sendPage(infoResolver());
  }, [infoResolver]);
};

type ClickHandler = (event?: any) => any;

export const useClickTracking = (
  infoResolver: () => Omit<ClickTrackingInfo, 'elem'>,
  clickHandler?: ClickHandler,
): ClickHandler => {
  return useCallback(
    (event: any) => {
      event?.preventDefault();
      event?.stopPropagation();
      setTimeout(() => Tracking.sendClick({ ...infoResolver(), elem: event?.target as HTMLElement }), 0);
      if (clickHandler) {
        return clickHandler(event);
      }
    },
    [clickHandler, infoResolver],
  );
};
